import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { FullPageSpinner } from './components/layout';

import EmailConfirmationPage from './pages/EmailConfirmationPage';

import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';
import DynamicPartnerRedirect from './utils/DynamicPartnerRedirect';
import OnboardingPage from './pages/OnboardingPage';
import OffersPage from './pages/OffersPage';
import BuyBoxPage from './pages/BuyBoxPage';
import PhotosPage from './pages/PhotosPage';
import OfferViewPage from './pages/OfferViewPage';
import SettingsPage from './pages/SettingsPage';
import HowPreLockDealWorksPage from './pages/HowPreLockDealWorksPage';
import MarketplaceReportPage from './pages/MarketplaceReportPage';
import EntitiesPage from './pages/EntitiesPage';
import AssetsPage from './pages/AssetsPage';
import OpportunitiesPage from './pages/OpportunitiesPage';

const LoginPage = lazy(() =>
  import(/* webpackChunkName: "LoginPage" */ './pages/LoginPage'),
);

export default () => (
  <Suspense fallback={<FullPageSpinner />}>
    <Switch>
      <Route path="/partner/:partnerName" component={DynamicPartnerRedirect} />
      {/* AUTH */}
      <Route path="/auth/:authState" component={LoginPage} />
      <Route path="/auth" component={LoginPage} />
      <Route path="/login" exact component={LoginPage} />
      <PrivateRoute
        exact
        path="/o/onboarding/:stepKey"
        component={OnboardingPage}
      />

      <PublicRoute
        path="/confirm-email"
        exact
        component={EmailConfirmationPage}
      />
      <PrivateRoute path="/" exact component={OffersPage} sidebar />
      <PrivateRoute path="/buybox" exact component={BuyBoxPage} sidebar />
      <PrivateRoute path="/settings" exact component={SettingsPage} sidebar />
      <PrivateRoute
        path="/deal/:dealSubmissionId"
        exact
        component={OfferViewPage}
        sidebar
      />
      <PublicRoute
        path="/deal/photos/:dealSubmissionId"
        exact
        component={PhotosPage}
        sidebar
      />
      <PrivateRoute
        path="/pre-lock-how-it-works"
        component={HowPreLockDealWorksPage}
        sidebar
      />
      <PrivateRoute
        path="/marketplace-report"
        component={MarketplaceReportPage}
        sidebar
      />
      <PrivateRoute path="/entities" component={EntitiesPage} sidebar />
      <PrivateRoute path="/assets" component={AssetsPage} sidebar />
      <PrivateRoute
        path="/opportunities"
        component={OpportunitiesPage}
        sidebar
      />

      <Redirect from="/o/onboarding" to="/o/onboarding/create" />
    </Switch>
  </Suspense>
);
